import React from 'react';
import Pageheader from '../utils/headerHelment';
import SoftwareInventory from '../components/SoftwareInventory';

const SoftwareInventoryPage = () => {
    return (
        <>
            <Pageheader title="LENS - Software Inventory" />
            <SoftwareInventory />
        </>
    );
};

export default SoftwareInventoryPage;
